import React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  sitePurple,
  siteLightBlue,
  siteDarkGreen,
  siteDarkBlue
} from "../../providers/Theme";

const tabs = [
  {
    label: "Board of Directors",
    path: "/about-us/our-team/board-of-directors",
    color: sitePurple
  },
  {
    label: "Strategic Team",
    path: "/about-us/our-team/strategic-team",
    color: siteLightBlue
  },
  {
    label: "Medical Advisory Council",
    path: "/about-us/our-team/medical-advisory-council",
    color: siteDarkGreen
  }
];

const Nav = styled.nav`
  background: white;
  padding: 0 2rem;
`;

const TabList = styled.div`
  max-width: 72rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;

  /* Stack vertically below 900px */
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const Tab = styled(Link)<{ $active: boolean; $color: string }>`
  position: relative;
  display: inline-block;
  padding: 1.25rem 2rem;
  font-weight: 800;
  font-size: 1.3rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-decoration: none;
  white-space: nowrap;
  color: ${({ $active, $color }) => ($active ? $color : siteDarkBlue)};
  transition: color 0.15s ease;

  /* Bottom underline on desktop */
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 2rem;
    right: 2rem;
    height: 3px;
    background: ${({ $active, $color }) => ($active ? $color : "transparent")};
    transition: background 0.15s ease;
  }

  &:hover {
    color: ${({ $color }) => $color};
    text-decoration: none;
  }

  /* Slightly smaller between 900-1100px to prevent overflow */
  @media (max-width: 1100px) and (min-width: 901px) {
    font-size: 1rem;
    padding: 1.25rem 1.25rem;
    &::after {
      left: 1.25rem;
      right: 1.25rem;
    }
  }

  /* Left border + stacked below 900px */
  @media (max-width: 900px) {
    white-space: normal;
    font-size: 1.1rem;
    padding: 1rem 1.25rem;
    border-left: 4px solid
      ${({ $active, $color }) => ($active ? $color : "#dde2ee")};
    background: ${({ $active }) => ($active ? "rgba(0,0,0,0.03)" : "transparent")};

    &::after {
      display: none;
    }
  }
`;

const TeamPageNav: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <Nav>
      <TabList>
        {tabs.map(tab => (
          <Tab
            key={tab.path}
            to={tab.path}
            $active={pathname === tab.path}
            $color={tab.color}
            onClick={() => window.scrollTo(0, 0)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>
    </Nav>
  );
};

export default TeamPageNav;
